import { render } from "./UNPRIORITIZED_BACKLOG_ADD_ITEM.vue?vue&type=template&id=7becd930&ts=true"
import script from "./UNPRIORITIZED_BACKLOG_ADD_ITEM.vue?vue&type=script&lang=ts"
export * from "./UNPRIORITIZED_BACKLOG_ADD_ITEM.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__